module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av394-cadd7801f38877bb352302f25bc3af5c.jpg";